import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { HelpService } from '~commonInfra/services/HelpService';

import { Messages } from '../../../codegen/Localize';
import { SettingsSection } from '../../components/common/SettingsSection';
import {componentRegistryEntry} from '../../general-settings/components/SettingsComponentRegistryFunctions';
import { learnMoreStyle} from '../../styles/CommonStyles';

export function DataConnectSettingsSummarySection() {
  return (
    <SettingsSection title={Messages.dataConnectSiteSettingsSection()}
                     testId={'DataConnect-settings-summary-section'}
                     description={renderDescription()}/>
  );
}

function renderDescription() {
    return <>
      <span data-tb-test-id='DataConnect-settings-summary'>{Messages.dataConnectSiteSettingsDescription()}</span>
      <TextLinkWidget testId={'DataConnect-settings-summary-learn-more'}
                      className={learnMoreStyle}
                      href={HelpService.getServerHelpUrlByCategory('DataConnect-live-query')}
                      target={'_blank'}>
      {Messages.siteRemoteAgentSettingsLearnMore()}
      </TextLinkWidget>
      </>;
}

/* for registering the component in settings registry */
export const DataConnectSettingsSummarySectionSpecs = componentRegistryEntry({
  name: 'DataConnectSettingsSummarySection',
  component: DataConnectSettingsSummarySection
});
